const TOKEN_KEY = 't'
const REFRESH_TOKEN_KEY = 'rt'
const LATEST_ADDRESS_JSON_STRINGIFY = 'lajs'
const CARD_BALANCE = 'balance'
const MOBILE_INSTALL_POPUP = 'seen_mobile_install_popup'
const SHOWN_VERIFICATION_POPUP = 'shown_verification_popup'
const GRAPHQL_ENDPOINT = 'graphql_endpoint'

export const LocalStorageKeys = {
    TOKEN_KEY,
    REFRESH_TOKEN_KEY,
    LATEST_ADDRESS_JSON_STRINGIFY,
    CARD_BALANCE,
    MOBILE_INSTALL_POPUP,
    SHOWN_VERIFICATION_POPUP,
    GRAPHQL_ENDPOINT,
}
